var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SortFilter/Scoreboard-Controls/V1",
    transform: "translate(-960.000000, -131.000000)",
    stroke: "#938E85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(893.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Group",
    transform: "translate(67.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 0.5,
    width: 6.27272727,
    height: 6.27272727
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 9.22727273,
    width: 6.27272727,
    height: 6.27272727
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.22727273,
    y: 9.22727273,
    width: 6.27272727,
    height: 6.27272727
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.22727273,
    y: 0.5,
    width: 6.27272727,
    height: 6.27272727
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/Grid.b6235913e70876242bd44cb4cef913f9.svg";
export { ForwardRef as ReactComponent };